import { CONVERSATION_ACTIVE_CONVERSATION } from '../conversationActive/types';

import * as ACTION_TYPES from './types';

function getUnique(arr, key) {
  const unique = arr
    .map(e => e[key])

    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)

    // eliminate the dead keys & store unique objects
    .filter(e => arr[e])
    .map(e => arr[e]);

  return unique;
}

const initialState = {
  status: {
    loading: -1,
    loadingGalleryBackward: -1,
    loadingGalleryForward: -1,
  },
  list: [],
  meta: {
    currentLength: -1,
    totalMedia: 0,
  },
  conversationId: -1,
  showGallery: false,
  previewImage: null,
  gallery: [],
  metaGallery: {
    lengthForward: -1,
    lengthBackward: -1,
  },
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.ALL_MEDIA_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 0,
        },
      };
    case ACTION_TYPES.ALL_MEDIA_RETRIEVE_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          loading: 1,
        },
        list: getUnique([...state.list, ...payload.data], 'id'),
        meta: {
          currentLength: payload.data.length,
          totalMedia: payload?.meta?.pagination?.total,
        },
      };
    }
    case ACTION_TYPES.ALL_MEDIA_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 2,
        },
        error,
      };
    case CONVERSATION_ACTIVE_CONVERSATION:
      return initialState;

    case ACTION_TYPES.GALLERY_VIEW_BACKWARD_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingGalleryBackward: 0,
        },
      };
    case ACTION_TYPES.GALLERY_VIEW_BACKWARD_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          loadingGalleryBackward: 1,
        },
        gallery: getUnique([...state.gallery, ...payload.data], 'id'),
        metaGallery: {
          ...state.metaGallery,
          lengthBackward: payload.data.length,
        },
      };
    }
    case ACTION_TYPES.GALLERY_VIEW_BACKWARD_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingGalleryBackward: 2,
        },
        error,
      };

    case ACTION_TYPES.GALLERY_VIEW_FORWARD_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingGalleryBackward: 0,
        },
      };
    case ACTION_TYPES.GALLERY_VIEW_FORWARD_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          loadingGalleryBackward: 1,
        },
        gallery: getUnique([...payload.data.reverse(), ...state.gallery], 'id'),
        metaGallery: {
          ...state.metaGallery,
          lengthForward: payload.data.length,
        },
      };
    }
    case ACTION_TYPES.GALLERY_VIEW_FORWARD_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingGalleryBackward: 2,
        },
        error,
      };

    case ACTION_TYPES.GALLERY_SET_PREVIEW_IMAGE:
      return {
        ...state,
        previewImage: payload.previewImage,
      };

    case ACTION_TYPES.GALLERY_TRIGGER_OPEN:
      return {
        ...state,
        gallery: [...state.gallery, ...payload.images],
        showGallery: true,
        previewImage: payload.previewImage,
        conversationId: payload.conversationId,
      };

    case ACTION_TYPES.GALLERY_TRIGGER_CLOSE:
      return {
        ...state,
        showGallery: false,
        previewImage: null,
        gallery: [],
        conversationId: -1,
        metaGallery: {
          lengthForward: -1,
          lengthBackward: -1,
        },
      };

    default:
      return state;
  }
}
